import type { FeedsDevice } from "./types";

export const feedsDevice: FeedsDevice = ({ feed, category, typeName }) => {
  if (!feed || category === "other") return false;
  if (!feed.categories.includes(category)) return false;
  return !typeName || !feed.excludedTypes.includes(typeName);
};
